import { Action } from "redux";

export const GET_BEACONS_FOR_ORGANIZATION =
  "BEACON:GET_BEACONS_FOR_ORGANIZATION";

export interface GetBeaconsForOrganizationAction extends Action {
  type: typeof GET_BEACONS_FOR_ORGANIZATION;
  organizationKeyName: string;
  filters: any;
  page: number;
}

export const getBeaconsForOrganizationAction = (
  organizationKeyName: string,
  filters: any,
  page: number
): GetBeaconsForOrganizationAction => ({
  type: GET_BEACONS_FOR_ORGANIZATION,
  organizationKeyName,
  filters,
  page,
});
